/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { EMonographPresentationFinalStatus } from "../types/EMonographPresentationFinalStatus.ts";

/**
 * @description 1 = Approved | 2 = Failed | 3 = TemporarilyReproved |
 */
export const eMonographPresentationFinalStatusSchema = z
  .union([z.literal(1), z.literal(2), z.literal(3)])
  .describe(
    "1 = Approved | 2 = Failed | 3 = TemporarilyReproved | ",
  ) as unknown as ToZod<EMonographPresentationFinalStatus>;
